module.exports = __webpack_public_path__ + "static/chirpyest-boards-e265060a87724dddc95796829f7dbd6e.png";